module.exports = new __parcel__URL__("poodle.b40487d6.svg").toString();